"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const SelectOptionsToJSX_1 = require("./SelectOptionsToJSX");
const form_1 = require("../../atoms/form");
const utils_1 = require("../../utils");
const hooks_1 = require("../../shared/hooks");
const setProperValueForSecondSelect = (areSelectsValuesEqual, values, availableWeeks) => {
    var _a;
    if (areSelectsValuesEqual || values.first === null)
        return "-";
    return values
        ? values.second
        : (_a = availableWeeks[availableWeeks.length - 1]) === null || _a === void 0 ? void 0 : _a.id.toString();
};
const isFirstSelectDisabled = (isMobile, availableWeeks, values) => {
    if (availableWeeks.length <= 1)
        return true;
    return !isMobile && !(values === null || values === void 0 ? void 0 : values.first);
};
exports.default = ({ availableWeeks, onFirstSelectChange, onSecondSelectChange, translations, values, noDefault, areSelectsValuesEqual, hasMeasurements }) => {
    var _a;
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)(form_1.Select, { onChange: onFirstSelectChange, value: values ? values.first + "" : ((_a = availableWeeks[0]) === null || _a === void 0 ? void 0 : _a.week) + "", disabled: isFirstSelectDisabled(isMobile, availableWeeks, values), children: [!noDefault && ((0, jsx_runtime_1.jsx)("option", { value: "", children: translations.choose }, "default")), availableWeeks.map((0, SelectOptionsToJSX_1.optionToJSX)((0, utils_1.capitalize)(translations.week)))] }, void 0), (0, jsx_runtime_1.jsxs)(form_1.Select, { onChange: onSecondSelectChange, value: setProperValueForSecondSelect(Boolean(areSelectsValuesEqual), values, availableWeeks), disabled: areSelectsValuesEqual || !hasMeasurements, children: [areSelectsValuesEqual && (0, jsx_runtime_1.jsx)("option", { value: "-", children: "-" }, void 0), !noDefault && ((0, jsx_runtime_1.jsx)("option", { value: "", children: translations.choose }, "default")), availableWeeks.map((0, SelectOptionsToJSX_1.optionToJSX)((0, utils_1.capitalize)(translations.week)))] }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex: 0;

  & > div {
    margin-right: ${({ theme }) => theme.spacings.m};
    width: 8.5rem;
  }

  & div[data-disabled="false"] svg {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div {
      margin-right: ${({ theme }) => theme.spacings.xs};
      width: 7.5rem;
    }

    & div:not(:focus) svg {
      color: ${({ theme }) => theme.colors.greyLighten70};
    }

    [data-selected="true"] + svg {
      color: ${({ theme }) => theme.colors.greyBase} !important;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.phoneSmall}) {
    flex-direction: column;
    flex: 1;
    width: 100%;

    & > div {
      width: 100%;
      margin-bottom: ${({ theme }) => theme.spacings.xs};
    }
  }
`;
//# sourceMappingURL=SelectGroup.js.map